import { IGDPRSettings, IOptInOutAction, ActionType } from "./types";

export const configure = (settings: IGDPRSettings): IOptInOutAction => ({
    type: ActionType.Configure,
    payload: settings,
});
